export default {
    searchBy: 'Search by Group Name',
    search: 'Search',
    createGroup: 'Create Group',
    groupName: 'Group Name',
    updateAt: 'Update At',
    createdAt: 'Created At',
    workDay: 'Work Day',
    numberOfPeople: 'Number of People',
    deleteGroup: 'Delete Group',
    congratulation: 'Congratulation',
    msgDeleteSuccess: 'Group is deleted.',
    questionDelete: 'Are you sure to delete "$Name" group?'
}
